import React, { useEffect } from 'react';
import Loader from "react-loaders";
import { useHistory, withRouter } from 'react-router-dom';

import { getToken } from '../../utils/getToken';
import allPaths from '../../route/allPaths';
import { getRedirectURL, removeRedirectURL } from '../../utils/getToken';
import { setFabItem,setSideBarItems } from '../../reducers/ThemeOptions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const Landing = (props) => {
  let token = getToken();
  let history = useHistory()

  useEffect(() => {
    if(token) {
      redirect_func()
    } else {
      if(process.env.REACT_APP_LANDING_URL) {
        window.location.href = process.env.REACT_APP_LANDING_URL;
      } else {
        redirect_cw_home_page()
      }
    }
  }, [token]);

  const redirect_cw_home_page = () => {
    pushURL(allPaths.HOME_ROUTE);
  }

  useEffect(()=>{
    setDefaultFabAndSideBar()
  },[])

  const setDefaultFabAndSideBar = () => {
    const { setFabItem, setSideBarItems } = props;
    setFabItem(false);
    setSideBarItems([]);
  }

  const redirect_func = () => {
    let url = getRedirectURL();
    if(url) {
      removeRedirectURL();
      pushURL(url);
    } else {
      pushURL(allPaths.HOME_ROUTE);
    }
  }

  const pushURL = (url) => {
    history && history.push(url)
  }

  return (
    <div className='d-flex justify-content-center align-items-center h-100'>
      <Loader color="#003EFD" type="ball-pulse"/>
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setSideBarItems,
      setFabItem
    },
    dispatch
  );
}

export default connect(null,mapDispatchToProps)(withRouter(Landing)) ;